function doHandleMonth(month) {
  var m = month;
  if (month.toString().length == 1) {
    m = '0' + month;
  }
  return m;
}

export const getDay = (day) => {
  var today = new Date();

  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;

  today.setTime(targetday_milliseconds); //注意，这行是关键代码

  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + '-' + tMonth + '-' + tDate;
};

export const getDate = () => {
  let days = [];
  let day = new Date();
  for (let i = 0; i <= 144; i += 24) {
    //144是前六天的小时数
    let dateItem = new Date(day.getTime() - i * 60 * 60 * 1000); //使用当天时间戳减去以前的时间毫秒（小时*分*秒*毫秒）

    let y = dateItem.getFullYear(); //获取年份
    let m = (dateItem.getMonth() + 1).toString().padStart(2, '0'); //获取月份并补零，月份从0开始，需要+1
    let d = dateItem.getDate().toString().padStart(2, '0'); //获取日期并补零
    let hms = '';
    if (i == 0) {
      // 当天的时分秒
      let h = dateItem.getHours().toString().padStart(2, '0');
      let m = dateItem.getMinutes().toString().padStart(2, '0');
      let s = dateItem.getSeconds().toString().padStart(2, '0');
      hms = h + ':' + m + ':' + s;
    } else {
      hms = '00:00:00';
    }
    days.push(y + '-' + m + '-' + d + ' ' + hms);
  }
  //   console.log('最近七天日期', days);
  return days;
};
